<template>
<b-container
  class="py-5 d-flex section"
  style="background-color: #08034c;"
  fluid
  >
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col>
      
      <b-container fluid>
	<b-row class="text-light text-center">
	  <b-col
	    cols="12"
	    md="10"
	    offset-md="1"
	    lg="8"
	    offset-lg="2"
	    xl="6"
	    offset-xl="3"
	    >
	    <div class="py-5 p-sm-5">
	      <slot name="intro">
		<h2>All TrinApps are available inside the main Construction LaunchPad</h2>
	      </slot>
	    </div>
	    <div class="py-3 text-center">
	      <slot name="icon">
		<!--b-img
		  :src="require('../assets/trinapp_construction.png')"
		  class="mb-3"
		  style="height: 120px;"
		  /-->
		<b-img
		  :src="require('../assets/launchpad.png')"
		  class="mb-3"
		  style="height: 120px;"
		  />
	      </slot>
	      <slot name="title">
		<h1 class="my-auto">LaunchPad</h1>
	      </slot>
	    </div>
	    <div class="py-5 mx-auto text-left">
	      <slot name="description">
		<p>Use LaunchPad to access your other TrinApps.</p>
	      
		<p>Use LaunchPad to navigate your information in your TrinPod<sup>&trade;</sup> and to launch and use any TrinApp<sup>&trade;</sup>.</p>
	      
		<p>In LaunchPad, you can simultaneously view the same information in different views and in different apps, creating an effective way of working.</p>
	      </slot>
	    </div>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col>
	    <div class="text-center mb-5">
	      <slot name="buttons">
		<b-button
		  size="lg"
		  class="btn-orange mt-5 mx-3"
		  href="https://trinpod.us/pricing?industry=construction"
		  >
		  Get Started
		</b-button>
	      </slot>
	    </div>
	  </b-col>
	</b-row>
      </b-container>
      
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "Layout12",
}
</script>
